import { createAction, props } from '@ngrx/store';

const GET_CODE_GENERATION = '[CodeGeneration] Get CodeGeneration';
const SAVE_CODE_GENERATION = '[CodeGeneration] Save CodeGeneration';
const UPDATE_CODE_GENERATION = '[CodeGeneration] Update CodeGeneration';
const DELETE_CODE_GENERATION = '[CodeGeneration] Delete CodeGeneration';
const GENERATE_BE_CODE = '[CodeGeneration] Generate BE Code';
const GENERATE_BE_CODE_STATUS = '[CodeGeneration] Generate BE Code Status';
const PUSH_CODE_TO_GIT = '[CodeGeneration] Push Code to Git';
const PUSHED_CODE_TO_GIT = '[CodeGeneration] Pushed Code to Git';
const PULL_CODE_FROM_GIT = '[CodeGeneration] Pull code from git';
const PULLED_CODE_FROM_GIT = '[CodeGeneration] Pulled code from git';
const GIT_PUSH_POLLING = '[CodeGeneration] git push polling';
const SYN_TO_GIT = '[CodeGeneration] git sync';
const SYNED_TO_GIT = '[CodeGeneration] git synced';

const getCodeGeneration = createAction(GET_CODE_GENERATION, props<{ codeGenApiConstants: any }>());

const saveCodeGeneration = createAction(SAVE_CODE_GENERATION, props<{ codeGenerationData: any }>());

const updateCodeGeneration = createAction(UPDATE_CODE_GENERATION, props<{ codeGenerationData: any }>());

const deleteCodeGeneration = createAction(DELETE_CODE_GENERATION, props<{ codeGenerationId: string }>());

const generateBECode = createAction(GENERATE_BE_CODE, props<{ genBECodeApi: any }>());

const generateBECodeStatus = createAction(GENERATE_BE_CODE_STATUS, props<{ beCodeGenStatus: any }>());

const pushCodeToGit = createAction(PUSH_CODE_TO_GIT, props<{ pushToGitApi: any }>());

const pushedCodeToGit = createAction(PUSHED_CODE_TO_GIT, props<{ gitCommitStatus: any }>());

const pullCodeFromGit = createAction(PULL_CODE_FROM_GIT, props<{ pullFromGitApi: any }>());

const pulledCodeFromGit = createAction(PULLED_CODE_FROM_GIT, props<{ gitPullStatus: any }>());

const syncToGit = createAction(SYN_TO_GIT, props<{ syncToGitApiConstants: any }>());

const syncedToGit = createAction(SYNED_TO_GIT, props<{ syncToGitStatus: any }>());

const getPushStatus = createAction(GIT_PUSH_POLLING, props<{ gitStatusApi: any; gitParams: any }>());
export {
  getPushStatus,
  getCodeGeneration,
  saveCodeGeneration,
  updateCodeGeneration,
  deleteCodeGeneration,
  generateBECode,
  generateBECodeStatus,
  pushCodeToGit,
  pushedCodeToGit,
  pullCodeFromGit,
  pulledCodeFromGit,
  syncToGit,
  syncedToGit
};
